import { render, staticRenderFns } from "./EditVendor.vue?vue&type=template&id=55c18548&scoped=true&"
import script from "./EditVendor.vue?vue&type=script&lang=js&"
export * from "./EditVendor.vue?vue&type=script&lang=js&"
import style0 from "./EditVendor.vue?vue&type=style&index=0&id=55c18548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c18548",
  null
  
)

/* custom blocks */
import block0 from "./EditVendor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports